import { useState } from 'react';

/**
 * This is a custom hook to determine if the dialog consists of a `Datepicker` component.
 * If so the `enforceFocusFlag` is set to `true` momentarily to allow the control to go out of a `Dialog`.
 * TODO: This is a dirty hack and get rid of this code once we switch the date picker with some other lib.
 */
function useEnforceFocusFlag() {
  var _useState = useState(false),
    disableEnforceFocusFlag = _useState[0],
    setEnforceFocusFlag = _useState[1];
  var onFocus = function onFocus(e) {
    if (e.target.querySelector('.DateInput_input')) {
      setEnforceFocusFlag(true);
    }
  };
  var onBlur = function onBlur(e) {
    if (e.target.getAttribute && e.target.getAttribute('tabindex') === '0') {
      setEnforceFocusFlag(false);
    }
  };
  return [disableEnforceFocusFlag, onFocus, onBlur];
}
export default useEnforceFocusFlag;